package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun TaskStatus(
    status: TaskModel.Status?,
    suffixIconRes: String? = null,
    modifier: Modifier = Modifier,
) {
    val text = remember(status) {
        when (status) {
            TaskModel.Status.Todo -> "To do"
            TaskModel.Status.Done -> "Done"
            TaskModel.Status.Blocked -> "Blocked"
            TaskModel.Status.Archive -> "Archive"
            null -> "Change"
        }
    }

    val esColorScheme = MaterialTheme.esColorScheme
    val color = remember(status) {
        when (status) {
            null -> Color.White
            TaskModel.Status.Todo -> esColorScheme.textWarning
            TaskModel.Status.Done -> esColorScheme.bgSuccess
            TaskModel.Status.Blocked -> esColorScheme.destructive
            TaskModel.Status.Archive -> esColorScheme.destructiveHover
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = modifier
            .background(color, CircleShape)
            .padding(
                vertical = EsConstants.StatusDropdownVerticalPadding,
                horizontal = EsConstants.StatusDropdownHorizontalPadding,
            ),
    ) {
        Text(
            text = text,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        suffixIconRes?.let {
            EsLargeIcon(
                res = it,
                tint = MaterialTheme.esColorScheme.iconPrimary,
            )
        }
    }
}